import { render, staticRenderFns } from "./carmonthRuleForm.vue?vue&type=template&id=f2b135ce&scoped=true&"
import script from "./carmonthRuleForm.vue?vue&type=script&lang=js&"
export * from "./carmonthRuleForm.vue?vue&type=script&lang=js&"
import style0 from "./carmonthRuleForm.vue?vue&type=style&index=0&id=f2b135ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b135ce",
  null
  
)

export default component.exports